const currenciesMap = {
  PLN: 'zł',
  EUR: '€',
  NOK: 'kr',
};

export const currencyToSymbol = currency =>
  currenciesMap[currency.toUpperCase().trim()] || currency;
